import clsx from 'clsx'
import style from './LoadingSpinner.module.sass'

export function LoadingSpinner(props: { active?: boolean }) {
	return <span className={clsx(style.container, props.active && style.active)}></span>
}
